export default __webpack_public_path__ + "static/media/06_gallery.b1040a0d.jpg";